import { createElement, memo, useCallback, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import Button from '@hfe/max-button';
import VapView from '../../../components/vap-view';
import Animated from '@max/mbc-animated';
import AnimateView from '@max/mbc-animate-view';
import { CITY_ITEM_HAND_VAP } from '../../../const';
import './index.scss';
const isWeb = true;
function ModalCityItem(props) {
    const { onSelectCity, cardGroupInfoVO, showHandVap = false, index = 0 } = props;
    const { name, iconUrl } = cardGroupInfoVO ?? {};
    // 小手透明度动画 ref
    const handOpacity = useRef(new Animated.Value(1));
    const handleHandFadeOut = useCallback(() => {
        const timer = setTimeout(() => {
            Animated.timing(handOpacity.current, {
                toValue: 0,
                duration: 1000,
                useNativeDriver: true
            }).start();
            clearTimeout(timer);
        }, 5000);
    }, []);
    return <Button className="modal-city-item__outer-wrapper" onPress={() => {
        onSelectCity(cardGroupInfoVO);
    }}>
      <Image source={{
        uri: iconUrl || ''
    }} className="modal-city-item__background" resizeMode="cover"/>
      <View className="modal-city-item__inner-wrapper">
        <Text className="modal-city-item__city-name" numberOfLines={1}>
          {name}
        </Text>
        <View className="modal-city-item__button">
          <Text className="modal-city-item__button-text">去出发</Text>
        </View>
      </View>

      
      {showHandVap && <AnimateView className="modal-city-item__hand-wrapper" animateStyles={{
        opacity: handOpacity.current
    }}>
          <VapView {...CITY_ITEM_HAND_VAP} autoPlay loop={true} keepLastFrame width={isWeb ? 120 : 60} height={isWeb ? 120 : 60} widthInRpx={120} widthHeightRatio={1} onStart={() => {
        handleHandFadeOut();
    }}/>
        </AnimateView>}
    </Button>;
}
export default memo(ModalCityItem);
